import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { studentLinkedInLogin } from '../services/studentLogin';
import { useDispatch } from 'react-redux';
import {
  loginSuccess,
  userID,
  userType,
  setUserDetails,
  setToken,
  updateStepCompletion,
  updatePermissions
} from '../Store/Action';
import { showToastAlert } from '../admin/components/CustomAlert';

const LinkedInCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleLinkedInCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
          showToastAlert(`LinkedIn login failed: ${error}`, 'error');
          navigate('/student/login');
          return;
        }

        if (!code) {
          showToastAlert('No authorization code received', 'error');
          navigate('/student/login');
          return;
        }

        // Send code to backend to exchange for access token and user data
        const response = await studentLinkedInLogin(code);

        if (response.status === 200) {
          const data = response.data;
          dispatch(setToken(data.token));
          dispatch(userID(data.user._id));
          dispatch(updateStepCompletion(data.stepsCompleted));
          dispatch(updatePermissions(data.user.permissions));
          dispatch(userType("student"));
          dispatch(
            setUserDetails({
              name: data.user.name,
              email: data.user.email,
              status: data.user.status,
              isApproved: data.user.isApproved
            })
          );
          dispatch(loginSuccess(true));
          showToastAlert('LinkedIn login successful!', 'success');
          navigate('/student/applications');
        } else {
          showToastAlert(response.data?.message || 'Login failed', 'error');
          navigate('/student/login');
        }
      } catch (error) {
        console.error('LinkedIn callback error:', error);
        showToastAlert('An error occurred during LinkedIn login', 'error');
        navigate('/student/login');
      }
    };

    handleLinkedInCallback();
  }, [searchParams, navigate, dispatch]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}
    >
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>Processing LinkedIn login...</Typography>
    </Box>
  );
};

export default LinkedInCallback;
